import * as moment from 'moment';

export const convertYearDayToDate = (year, day) => {
  const date = new Date(year, 0);
  date.setDate(day);
  date.setHours(0);
  date.setMinutes(0);
  return date;
};

export const getDateOfYearDayAndTime = (year, day, slotTime) => {
  const slotDate = convertYearDayToDate(year, day);
  // eslint-disable-next-line radix
  slotDate.setHours(parseInt(slotTime.split(':')[0]));
  // eslint-disable-next-line radix
  slotDate.setMinutes(parseInt(slotTime.split(':')[1]));
  return slotDate;
};

export const getVisitRequestedDates = visit => {
  let requestedFor1 = '-';
  let requestedFor2 = '-';
  let requestedForDate;
  if (visit.requested_booking_slot_1) {
    requestedForDate = convertYearDayToDate(visit.requested_booking_slot_1.year, visit.requested_booking_slot_1.day);
    requestedFor1 = `${moment(requestedForDate).format('DD/MM/YYYY')} ${visit.requested_booking_slot_1.day_of_week} ${visit.requested_booking_slot_1.slot_begin} - ${visit.requested_booking_slot_1.slot_end}`;
    if (visit.requested_booking_slot_2) {
      const requested2Date = convertYearDayToDate(visit.requested_booking_slot_2.year, visit.requested_booking_slot_2.day);
      requestedFor2 = `${moment(requested2Date).format('DD/MM/YYYY')} ${visit.requested_booking_slot_2.day_of_week} ${visit.requested_booking_slot_2.slot_begin} - ${visit.requested_booking_slot_2.slot_end}`;
    }
  }
  return {
    requestedFor1,
    requestedFor2,
    requestedDate: requestedForDate,
  };
};

export const getVisitBookedForDate = visit => {
  let bookedFor = '-';
  let bookedForDate;
  if (visit.booked_slot) {
    bookedForDate = convertYearDayToDate(visit.booked_slot.year, visit.booked_slot.day);
    bookedFor = `${moment(bookedForDate).format('DD/MM/YYYY')} ${visit.booked_slot.day_of_week} ${visit.booked_slot.slot_begin} - ${visit.booked_slot.slot_end}`;
  }
  return {
    bookedFor,
    bookedForDate,
  };
};

export const getDuration = (start, end) => {
  // start time and end time
  const startTime = moment(start, 'HH:mm:ss a');
  const endTime = moment(end, 'HH:mm:ss a');

  // calculate total duration
  return moment.duration(endTime.diff(startTime)).asHours();
}

export const getErrorInfo = err => {
  let errorMessage = null;
  if (err && err.response && err.response.data) {
    errorMessage = err.response.data;
  }
  return errorMessage;
}
